module.exports = __webpack_public_path__ + "img/staffList.5da1abbf.svg";